import React from 'react';
import { Icon } from './Icon';

/** Treat |delta| below this as flat (scorecard/drill rounding is 1 decimal). */
export const FLAT_DELTA_EPS = 0.05;

export function deltaIsFlat(value: number | null | undefined): boolean {
  return value == null || Number.isNaN(value) || Math.abs(value) < FLAT_DELTA_EPS;
}

export function Delta({
  value,
  suffix = '%',
  invert = false,
  size = 14,
}: {
  value: number | null;
  suffix?: string;
  invert?: boolean;
  size?: number;
}) {
  if (value == null || Number.isNaN(value)) {
    return <span style={{ color: 'var(--ink-3)', fontSize: size }}>-</span>;
  }
  if (deltaIsFlat(value)) {
    return (
      <span
        className="delta delta-flat"
        style={{
          color: 'var(--ink-3)',
          fontSize: size,
          fontWeight: 700,
        }}
      >
        —
      </span>
    );
  }
  const up = value > 0;
  const good = invert ? !up : up;
  const color = good ? 'var(--st-steady)' : 'var(--st-alert)';
  return (
    <span
      className="delta"
      style={{
        color,
        fontSize: size,
        fontWeight: 700,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Icon name={up ? 'arrowUp' : 'arrowDown'} size={size} stroke={2.4} />
      {up ? '+' : ''}
      {value}
      {suffix}
    </span>
  );
}
